import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { DepositAddressCard } from '@/components/features/deposits/DepositAddressCard';
import { DepositTransactionList } from '@/components/features/deposits/DepositTransactionList';
import { useDepositStatus } from '@/lib/hooks';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { ROUTES } from '@/config/routes';
import {DepositAddress} from "@/lib/types";

export const Route = createFileRoute('/_auth/deposits/$address')({
  component: DepositDetailComponent,
});

function DepositDetailComponent() {
  const { address } = Route.useParams();
  const { data, isLoading, isError, error } = useDepositStatus(address, true);

  const breadcrumbs = [
    { label: 'Deposits', href: ROUTES.DEPOSITS },
    { label: address },
  ];

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title={error.name} message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <Breadcrumbs items={breadcrumbs} />
      
      <PageHeader
        title="Deposit Details"
        description={`Monitor deposits to address ${address}`}
      />

      <DepositAddressCard
        address={{
            address: address,
        } as DepositAddress}
      />

      <DepositTransactionList transactions={data!.transactions} />
    </div>
  );
}
